export const LegalInfoProviderEnum = Object.freeze({
  DADATA: 'dadata',
  //...
});
